'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import PropTypes from 'prop-types';
import StaticTextProvider from '@/components/context/StaticTextProvider';
import { LogoSvg } from '../ui/data-display/logos/LogoSvg';
import { BubbleSvg } from '../ui/images/bubble-placeholder/BubbleSvg';
import { Footer } from './Footer';
import { Header } from './Header';
import { Main } from './Main';

const queryClient = new QueryClient();

export const LayoutManager = ({
	children,
	layout,
	staticTexts,
	breadcrumbs,
	header,
	footer,
	language,
	alternativeLinks,
	socialData,
	shoppingCartLink,
}) => {
	return (
		<StaticTextProvider value={staticTexts}>
			<QueryClientProvider client={queryClient}>
				<NuqsAdapter>
					<Header
						data={header}
						shoppingCartLink={shoppingCartLink}
						alternativeLinks={alternativeLinks}
						language={language}
						socialData={socialData}
					/>

					<Main layout={layout} breadcrumbs={breadcrumbs} language={language}>
						{children}
					</Main>
					<Footer data={footer} layout={layout} language={language} />
					<LogoSvg />
					<BubbleSvg />
				</NuqsAdapter>
			</QueryClientProvider>
		</StaticTextProvider>
	);
};

LayoutManager.propTypes = {
	children: PropTypes.node.isRequired,
};
